module.exports = __webpack_public_path__ + "static/media/ziranmei1.7d1fb976.png";